import ChannelSection from '../containers/channels/channel-section';
import Container from '../containers/container';
import SearchInput from '../form/search-input';
import { VStack } from '../layouts/stack.layout';

const styles = {
  header: 'py-4 px-2',
  content: '',
};

export default function ChannelsHeader() {
  return (
    <Container extensions="relative">
      <Container extensions="">
        <VStack extensions={styles.header}>
          <SearchInput
            value={''}
            set={() => {}}
            placeholder="Search for channel"
          />
        </VStack>
        <VStack extensions={styles.content}>
          <ChannelSection query="GROUP" title="Channels" />
        </VStack>
      </Container>
    </Container>
  );
}
